import React from 'react';
import { BookOpen, ScanLine, Clock, Users } from 'lucide-react';

interface MetricSummary {
  totalBooks: number;
  totalApproved: number;
  totalPending: number;
  totalDrafts: number;
  totalArchived: number;
  totalScans: number;
  totalUsers: number;
}

interface MetricCardsGridProps {
  summary: MetricSummary;
  rolesCount?: {
    penerbit?: number;
    penulis?: number;
  };
}

export const MetricCardsGrid: React.FC<MetricCardsGridProps> = ({ summary, rolesCount }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3.5 sm:gap-4">
      {/* Total Books */}
      <div className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-200/90 shadow-2xs">
        <div className="flex items-center justify-between text-slate-500 mb-2">
          <span className="text-xs font-semibold">Total Buku Terdaftar</span>
          <div className="w-8 h-8 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center">
            <BookOpen className="w-4 h-4" />
          </div>
        </div>
        <div className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
          {summary.totalBooks}
        </div>
        <div className="text-[11px] text-slate-500 mt-1 flex items-center gap-1">
          <span className="text-emerald-600 font-semibold">{summary.totalApproved}</span> aktif ber-UIBN
        </div>
      </div>

      {/* Total Scans */}
      <div className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-200/90 shadow-2xs">
        <div className="flex items-center justify-between text-slate-500 mb-2">
          <span className="text-xs font-semibold">Total Pemindaian</span>
          <div className="w-8 h-8 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center">
            <ScanLine className="w-4 h-4" />
          </div>
        </div>
        <div className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
          {summary.totalScans}
        </div>
        <div className="text-[11px] text-slate-500 mt-1">
          Barcode 1D & QR Code 2D
        </div>
      </div>

      {/* Pending Approval */}
      <div className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-200/90 shadow-2xs">
        <div className="flex items-center justify-between text-slate-500 mb-2">
          <span className="text-xs font-semibold">Menunggu Verifikasi</span>
          <div className="w-8 h-8 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center">
            <Clock className="w-4 h-4" />
          </div>
        </div>
        <div className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
          {summary.totalPending}
        </div>
        <div className="text-[11px] text-slate-500 mt-1">
          Naskah diajukan penerbit/penulis
        </div>
      </div>

      {/* Active Entities */}
      <div className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-200/90 shadow-2xs">
        <div className="flex items-center justify-between text-slate-500 mb-2">
          <span className="text-xs font-semibold">Entitas Terdaftar</span>
          <div className="w-8 h-8 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center">
            <Users className="w-4 h-4" />
          </div>
        </div>
        <div className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
          {summary.totalUsers}
        </div>
        <div className="text-[11px] text-slate-500 mt-1 flex items-center gap-1">
          <span>{rolesCount?.penerbit || 1} Penerbit</span> • <span>{rolesCount?.penulis || 1} Penulis</span>
        </div>
      </div>
    </div>
  );
};
